import getPublicRoutes from './getPublicRoutes';
import getProtectedRoutes from './getProtectedRoutes';
import { IUser } from 'src/lib/schemas';

const getRoutes = (user: IUser | null) => [
	{
		path: '',
		children: [getPublicRoutes(), getProtectedRoutes(user)],
	},
];

export default getRoutes;
